import { FC, ReactNode } from 'react'
import cn from 'classnames'
import style from '@src/components/SingleProductGroup/SingleProductGroup.module.scss'
import { CheckBoxFormik } from '@src/components/CheckBoxFormik/CheckBoxFormik'

type SingleProductGroupProps = {
  label?: string | ReactNode
  checked: boolean
  disabled?: boolean
  onChange: (value: any) => void
}

export const SingleProductGroup: FC<SingleProductGroupProps> = ({
  label, checked, onChange, disabled,
}) => (
  <div className={cn(style.singleProductGroup, checked && style.active)}>
    <CheckBoxFormik
      onChange={onChange}
      className={style.checkBoxSize}
      name="rememberMe"
      label={label}
      checked={checked}
      disabled={disabled}
    />
  </div>
)
